// Hero video loop counter. Replays the contained <video> until `data-loop-count`
// is reached, then leaves it paused on its final frame. Defaults (0 or missing)
// rely on the native loop attribute on the video element.

class HeroVideoLoop extends HTMLElement {
  connectedCallback() {
    const video = this.querySelector('video');
    if (!video) return;

    const target = parseInt(this.dataset.loopCount ?? '0', 10);
    if (!Number.isFinite(target) || target < 1) return;

    let playCount = 0;
    this.handleEnded = () => {
      playCount += 1;
      if (playCount < target) {
        const resume = video.play();
        if (resume && typeof resume.catch === 'function') {
          resume.catch(() => {});
        }
      }
    };

    video.addEventListener('ended', this.handleEnded);
  }

  disconnectedCallback() {
    const video = this.querySelector('video');
    if (video && this.handleEnded) {
      video.removeEventListener('ended', this.handleEnded);
    }
  }
}

if (!customElements.get('hero-video-loop')) {
  customElements.define('hero-video-loop', HeroVideoLoop);
}
